import { render } from "./SingleSessionCard2.vue?vue&type=template&id=333a6bac&scoped=true"
import script from "./SingleSessionCard2.vue?vue&type=script&lang=js"
export * from "./SingleSessionCard2.vue?vue&type=script&lang=js"

import "./SingleSessionCard2.vue?vue&type=style&index=0&id=333a6bac&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-333a6bac"]])

export default __exports__